"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorFunctionFactoryTermHasLang = void 0;
const bus_function_factory_1 = require("@comunica/bus-function-factory");
const utils_expression_evaluator_1 = require("@comunica/utils-expression-evaluator");
const TermFunctionHasLang_1 = require("./TermFunctionHasLang");
/**
 * A comunica TermFunctionIsTriple Function Factory Actor.
 */
class ActorFunctionFactoryTermHasLang extends bus_function_factory_1.ActorFunctionFactoryDedicated {
    constructor(args) {
        super({
            ...args,
            functionNames: [utils_expression_evaluator_1.SparqlOperator.HAS_LANG],
            termFunction: true,
        });
    }
    async run(_) {
        return new TermFunctionHasLang_1.TermFunctionHasLang();
    }
}
exports.ActorFunctionFactoryTermHasLang = ActorFunctionFactoryTermHasLang;
//# sourceMappingURL=ActorFunctionFactoryTermHasLang.js.map